import React, { useState } from 'react';
import TableComponent from './tableComponent';
import "./addressInfo.css";
import axios from 'axios';
import config from '../../../../config/environment';


export default function SearchByToAddr () {
    let PAGE = 1;

    const [infoState, setInfoState] = useState({
        tokenBlockchainCode: "",
        contractAddress: "",
        creationBlock: 0
    });

    const [errorInfoState, setErrorInfoState] = useState({
        tokenBlockchainCode: false,
        contractAddress: false,
        creationBlock: false,
        showTable: false,
        showRespError: false,
        textButton:"Submit",
        data: "",
        error: ""
    });

    const updateSelectValue = (event) => {
        setInfoState({
            ...infoState,
            tokenBlockchainCode: event.target.value
        })
        setErrorInfoState({
            ...errorInfoState,
            tokenBlockchainCode: false,
        })
    };

    const updateInpTxValue = (event) => {
        setInfoState({
            ...infoState,
            contractAddress: event.target.value
        })
        setErrorInfoState({
            ...errorInfoState,
            contractAddress: false,
            textButton: "Submit"
        })
    };

    const updateCreationBlock = (event) => {
        setInfoState({
            ...infoState,
            creationBlock: event.target.value
        })
        setErrorInfoState({
            ...errorInfoState,
            creationBlock: false,
            textButton: "Submit"
        })
    };

    const validateAddress = (addr) => {
        // return /([A-Fa-f0-9]{64})$/.test(addr);
        let tmp = addr.match(/([A-Fa-f0-9]{40})$/);
        
        if (tmp) {
            return true
        } else {
            return false
        }
    };

    const getInfo = async () =>{
        setErrorInfoState({
            ...errorInfoState,
            textButton: "Wait...",
            showRespError: false
        })

        if (infoState.tokenBlockchainCode === "DEFAULT" || !infoState.tokenBlockchainCode) {
            setErrorInfoState({
                ...errorInfoState,
                tokenBlockchainCode: true
            })
            return
        }

        if(!validateAddress(infoState.contractAddress)){
            setErrorInfoState({
                ...errorInfoState,
                contractAddress: true
            })
            return
        }
        
        if(!Number(infoState.creationBlock) && 0 !== Number(infoState.creationBlock)){
            setErrorInfoState({
                ...errorInfoState,
                creationBlock: true
            })
            return
        }

        try {
            let tmp = infoState.contractAddress;
            let reqBody ={
                tokenBlockchainCode: infoState.tokenBlockchainCode,
                contractAddress: tmp,
                creationBlock: Number(infoState.creationBlock)
            }
            let querry = config.backendUrl + "/micro-trustee/scrapping-info";
            await axios.post(querry, reqBody,{ headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            } }).then(
                (resp) => {
                    if(resp.data.eventsTotalList){
                        setErrorInfoState({
                            ...errorInfoState,
                            showTable: true,
                            data: resp.data,
                            textButton:"Submit"
                        }) 
                    }
                    
                    if(resp.data.error){
                        setErrorInfoState({
                            ...errorInfoState,
                            showTable: false,
                            showRespError: true,
                            data: resp.data,
                            textButton:"Submit",
                            error: resp.data.error
                        }) 
                    }
                }
            ).catch((error) => {
                alert(error.response.data.message)
                setErrorInfoState({
                    ...errorInfoState,
                    textButton:"Submit"
                })
            })
        } catch (error) {
            alert(error.response.data.message)
            setErrorInfoState({
                ...errorInfoState,
                textButton:"Submit"
            })
        }
    };
    
    return(
        <>
            <div className='searchBA_wrapper'>
                <select onChange={updateSelectValue} style={errorInfoState.tokenBlockchainCode ? {border: "3px solid red"} : {border: "1px solid #1F082B"}} className="select_network_item">
                    <option value="DEFAULT">Select the network</option>
                    <option value="BNB">BNB</option>
                    <option value="MATIC">MATIC</option>
                    <option value="ONE">ONE</option>
                </select>
                <input className="input_select_network_page" style={errorInfoState.contractAddress ? {border: "3px solid red"} : {border: "1px solid #1F082B"}} onChange={updateInpTxValue} type="text" placeholder='Contract address'/>
                <input className="input_select_network_page" style={errorInfoState.creationBlock ? {border: "3px solid red"} : {border: "1px solid #1F082B"}} onChange={updateCreationBlock} type="text" placeholder='Creation block'/>
                <button onClick={getInfo} className="searchBA_btn">{errorInfoState.textButton}</button>
            </div>
            <div className="history__table_wrapper_my">
                {
                    errorInfoState.showTable ? <TableComponent records = {errorInfoState.data.eventsTotalList} dataPages={`${errorInfoState.data.eventsTotal} записей`} pages = {PAGE}/> : null
                }
                {
                    errorInfoState.showRespError ? `${errorInfoState.error}` : null
                }
            </div>
        </>
    );
};
